import { v4 } from 'uuid';
import { setItem, removeItem, getItem } from '../persistedSessionState';

const SESSION_ID_KEY = 'sessionId';
const LAST_ACTIVITY_KEY = 'lastActivity';

const SESSION_TIMEOUT = 5 * 60 * 1000; // 5 minutes

const stopSession = (): void => {
  removeItem(SESSION_ID_KEY);
  removeItem(LAST_ACTIVITY_KEY);
};

/*
  Creates a new session if the session is expired or does not exist
  Updates the session last activity if the session already exists
  @returns {string} sessionId of the created or existing session
  @todo Ensure that errors don't create impossible states
*/
const handleSessionActivity = (): string => {
  if (isValidSession()) {
    setSessionLastActivity(Date.now().toString());
  } else {
    startSession();
  }

  // This call is guaranteed to return a string because of checks above
  return getSessionId()!;
};

const startSession = (): void => {
  setSessionId(v4());
  setSessionLastActivity(Date.now().toString());
};

const isValidSession = () => {
  const currentTime = Date.now();
  const id = getSessionId();
  const lastActivity = getSessionLastActivity();

  const isCurrentSessionValid =
    id && currentTime - Number(lastActivity) < SESSION_TIMEOUT;
  return isCurrentSessionValid;
};

const getSessionId = () => getItem(SESSION_ID_KEY);
const getSessionLastActivity = () => getItem(LAST_ACTIVITY_KEY);
const setSessionId = (value: string) => setItem(SESSION_ID_KEY, value);
const setSessionLastActivity = (value: string) =>
  setItem(LAST_ACTIVITY_KEY, value);

export { stopSession, handleSessionActivity, isValidSession };
